'use strict';

var trackingUtils = require('../modules/utils/tracking.utils');
var StoreCreditCards = require('./payment_manager/store_credit_cards');
var PaymentManagerModel = require('./paymentmanager.model');
var PaymentManagerView = require('./paymentmanager.view');
var postBookingUtils = require('../modules/utils/post_booking.utils');

var groupPaymentMethods = function(paymentMethods) {
    return Odigeo._.chain(paymentMethods)
        .groupBy('method')
        .map(function(cardTypes, method) {
            return {
                method: method,
                info: {
                    cardTypes: cardTypes,
                },
            };
        })
        .value();
};

var inputLabelCorrespondences = {
    nameoncard: 'owner',
    ccnumber: 'number',
    creditCardExpiration: 'expiration',
    cvv2: 'cvv',
};

module.exports = {
    modelClass: Odigeo.Model.extend(Odigeo._.extend(PaymentManagerModel, StoreCreditCards.model)),
    viewClass: Odigeo.View.extend(Odigeo._.extend(PaymentManagerView, StoreCreditCards.view, {
        selectors: Odigeo._.extend(PaymentManagerView.selectors, {
            invalidCard: '.post_booking_payment_invalid_card',
        }),

        onCreditCardTypeCodeChanged: function() {
            var creditCardTypeCode = this.model.get('creditCardTypeCode');
            var collectionMethods = this.model.get('collectionMethods');
            var isAccepted = postBookingUtils.isAcceptedCreditCardType(collectionMethods, creditCardTypeCode);
            this.$cachedSelectors.invalidCard.toggleClass('odf-hidden', isAccepted);
        },

        renderAcceptedCreditCardTypes: function(collectionMethods) {
            var template = Odigeo._.template(this.$cachedSelectors.acceptedCardsTemplate.html(), this.tmplSettings);
            var content = Odigeo._.chain(collectionMethods)
                .uniq(Odigeo._.property('code'))
                .map(template)
                .value();
            this.$cachedSelectors.acceptedCards.html(content);
        },
    })),

    init: function() {
        this.listenTo(this.model, 'cardChanges', this.cardDataChanged);
        this.view.listenTo(this.model, 'change:creditCardTypeCode', this.view.onCreditCardTypeCodeChanged);
        this.view.listenTo(this.model, 'change:chosenMethod', this.view.updatePaymentMethod);
        this.view.listenTo(this.model, 'change:chosenCard', this.view.updateCreditCard);
        this.view.listenTo(this.model, 'cardChanges', this.view.showErrors);

        StoreCreditCards.controller.initController.call(this);

        this.model.listenTo(this.view, 'change:cardData', this.model.setCardData);

        this.resetCardFields();

        this.view.cardFields = this.view.createFields(inputLabelCorrespondences);
    },

    resetCardFields() {
        this.view.$el.find('.cvv2_field').empty();
        this.view.$el.find('.name_on_card_field').empty();
        this.view.cardFields = {};
    },

    cardDataChanged: async function(changed) {
        var paymentData = await this.model.getRequest();
        var paymentDetails = Odigeo._.isNull(paymentData) ? {} : paymentData.paymentDetails;
        var changes = changed.changes[0];
        var validationErrors = this.model.validationError || '';
        const isCheckin = Odigeo._.get(this.model, 'widget.id', false) === 'seatmap-payment-checkin';
        if (!isCheckin) {
            this.trackFormErrorEvents(changes, validationErrors);
        }
        Odigeo.trigger(this.id + ':cardDataChanged', this.model.isValid(), paymentDetails);
    },

    trackFormErrorEvents: function(changed, errors) {
        if (changed === 'cardExpirationYear' || changed === 'cardExpirationMonth') {
            changed = 'creditCardExpiration';
        }
        var label = inputLabelCorrespondences[changed];
        var status = errors[changed] || '';
        this.trackError(status, label);
    },

    trackError: function(status, label) {
        if (status === 'invalid' || status === 'empty') {
            if (status === 'empty') {
                status = 'missing';
            }
            trackingUtils.trackEventWithCategory(
                'my_area_trips_details',
                'baggage_offline_add',
                'baggage_offline_fill_pay_fail_cccard_' + label + '_inline_' + status + '_error');
        }
    },

    setPaymentOptions: function(bookingId, collectionMethods) {
        this.model.set({
            collectionMethods: collectionMethods,
            paymentMethods: groupPaymentMethods(collectionMethods),
            chosenMethod: 'CREDITCARD',
            bookingId: bookingId,
        });
        this.view.renderAcceptedCreditCardTypes(collectionMethods);
        this.view.updatePaymentOptions(this.model);

        const firstCard = Odigeo._.get(collectionMethods, 0, this.model.get('presetCard'));
        this.model.set('presetCard', firstCard);
    },

    setCreditCardTypeCode: function(creditCardTypeCode, creditCardTypeName) {
        if (!creditCardTypeCode && !this.model.get('creditCardTypeCode')) {
            this.model.trigger('change:creditCardTypeCode');
        }
        this.model.set({
            creditCardTypeCode: creditCardTypeCode,
            creditCardTypeName: creditCardTypeName,
        });
        this.model.setCardType(creditCardTypeCode);
        this.view.cvvTypeChanged('AX' === creditCardTypeCode);
        this.view.model.get('cardFields').cvv2.setValidLength(this.model.getCvvLength(creditCardTypeCode));
    },

    cleanInputs() {
        this.model.set('creditCardData', {});
        this.model.resetCardFields();
        this.resetCardFields();
        this.view.cardFields = this.view.createFields(inputLabelCorrespondences);
        this.view.cleanInputs(true);
    },
};
